import { ContentType } from './types'

export function getContentTypeLabel (contentType: ContentType | null) {
  let contentTypeLabel = ''

  switch (contentType) {
    case ContentType.YI_COURSE_SECTION:
      contentTypeLabel = 'Course Section'
      break
    case ContentType.YI_CLASS:
      contentTypeLabel = 'Class'
      break
    case ContentType.YI_MEDITATION:
      contentTypeLabel = 'Meditation'
      break
    case ContentType.YI_COURSE:
      contentTypeLabel = 'Course'
      break
    case ContentType.YI_COURSE_SALES:
      contentTypeLabel = 'Course Sales Page'
      break
    case ContentType.YI_POSE:
      contentTypeLabel = 'Pose'
      break
    case ContentType.YI_ARTICLE:
      contentTypeLabel = 'Article'
      break
    default:
      break
  }
  return contentTypeLabel
}
